module.exports = __webpack_public_path__ + "Gauge4_Green-9cf06a39e29aea078a65dba4f26b163e.png";